import { useState } from "react";
import { Link } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import SingleProjectKickoff from "./SingleProjectKickoff";
import BulkKickoff from "./BulkKickoff";
import SingleProjectTileGen from "./SingleProjectTileGen";
import MultiProjectTileGen from "./MultiProjectTileGen";

const TAB_LIST = ["Single Project", "Bulk Kickoff", "Single Project Tiles", "Bulk Tiles Rollup"];

export default function PITPipeline() {
    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <div>
            <h1 style={{ textAlign: "center" }}>Historical DLR Pipeline</h1>
            <Typography
                variant="body2"
                style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto 16px", color: "#666" }}
            >
                Trigger individual phases or the full PIT/PLUM pipeline. Phase 1 generates PIT inputs, Phase 2
                aggregates coefficients, Phase 3 computes section historical DLR, and Phase 4 builds the line-level
                historical DLR rollup. Use Single Project to kick off one project; use Bulk Kickoff to multi-select
                projects under a client and run only those with the required inputs available. Tile-generation tabs
                let you re-tile a single project or build a combined rollup tileset (CONUS-style) from many.
            </Typography>
            <Typography
                variant="body2"
                style={{ textAlign: "center", maxWidth: "700px", margin: "0 auto 16px", color: "#666" }}
            >
                Prerequisite: Phase 1 runs on PIT inputs generated from an uploaded shapefile or KMZ. If the
                project geometry has not been ingested yet, upload it (or redrive a stored upload) on the{" "}
                <Link to="/calibration/pitUpload">PIT File Ingress</Link> page before kicking off the pipeline.
            </Typography>

            <Tabs
                value={selectedTab}
                onChange={(_, v) => setSelectedTab(v)}
                indicatorColor="primary"
                textColor="primary"
                centered
            >
                {TAB_LIST.map((label, i) => (
                    <Tab key={i} label={label} />
                ))}
            </Tabs>

            {selectedTab === 0 && <SingleProjectKickoff />}
            {selectedTab === 1 && <BulkKickoff />}
            {selectedTab === 2 && <SingleProjectTileGen />}
            {selectedTab === 3 && <MultiProjectTileGen />}
        </div>
    );
}
